import React, { useState } from "react";

import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import humanResourceImg from "../../assets/human_reource.png";

import { FaRobot, FaUserTie } from "react-icons/fa";

const styles = `
  .hr-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .hr-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .hr-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47, 183, 164, 0.7);
  }

  .hr-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 100%;
    max-width: 520px;
    box-sizing: border-box;
  }

  .hr-header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hr-header-badge span:first-of-type {
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .hr-arrow {
    margin-left: auto;
    flex-shrink: 0;
  }

  .hr-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .hr-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .hr-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .hr-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .hr-title-group h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .hr-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .hr-img-wrapper {
    flex: 1;
  }

  .hr-img-wrapper img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .hr-accordion {
    flex: 1.2;
  }

  .hr-accordion-item {
    margin-bottom: 18px;
  }

  .hr-accordion-header {
    background: linear-gradient(90deg, #2fb7a4 0%, #2f6f9f 60%, #2f4a7f 100%);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  .hr-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .hr-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet (≤ 1024px) ── */
  @media (max-width: 1024px) {
    .hr-header {
      height: auto;
      min-height: 90px;
    }

    .hr-header-badge {
      max-width: 100%;
      padding: 10px 14px;
    }

    .hr-title-group h2 {
      font-size: 26px;
    }

    .hr-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── Small tablet / large phone (≤ 768px) ── */
  @media (max-width: 768px) {
    .hr-header {
      flex-direction: column;
      height: auto;
    }

    .hr-header-left {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .hr-header-right {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .hr-triangle-left,
    .hr-triangle-right {
      width: 50px;
    }

    .hr-title-group h2 {
      font-size: 22px;
    }

    .hr-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .hr-img-wrapper {
      width: 100%;
    }

    .hr-img-wrapper img {
      max-width: 100%;
    }

    .hr-accordion {
      width: 100%;
    }
  }

  /* ── Mobile (≤ 480px) ── */
  @media (max-width: 480px) {
    .hr-header {
      flex-direction: column;
      height: auto;
    }

    .hr-header-left {
      min-height: 60px;
      padding: 10px 12px;
    }

    .hr-header-badge {
      padding: 10px 12px;
      gap: 8px;
    }

    .hr-header-badge span:first-of-type {
      font-size: 12px;
    }

    .hr-header-icon-box {
      width: 30px;
      height: 30px;
      min-width: 30px;
    }

    .hr-header-right {
      min-height: 60px;
      padding: 10px 12px;
    }

    .hr-triangle-left,
    .hr-triangle-right {
      width: 36px;
    }

    .hr-title-group h2 {
      font-size: 18px;
    }

    .hr-title-group svg {
      font-size: 24px !important;
      flex-shrink: 0;
    }

    .hr-main {
      padding: 20px 12px;
      gap: 20px;
    }

    .hr-accordion-header {
      font-size: 13px;
      padding: 8px 14px;
    }

    .hr-accordion-arrow {
      font-size: 18px;
    }

    .hr-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }
  }

  /* ── Extra small (≤ 360px) ── */
  @media (max-width: 360px) {
    .hr-title-group h2 {
      font-size: 15px;
    }

    .hr-accordion-header {
      font-size: 12px;
      padding: 6px 10px;
    }
  }
`;

function HumanResourcePage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Resume screening and candidate shortlisting",
      content:
        "Robots can effortlessly gather all the files and compare the information with the list of job requirements."
    },
    {
      title: "2.Offer letter administration",
      content:
        "Robots can quickly gather all the needed information, create the offer letter, send it, and eventually monitor the appropriateness of returned documents."
    },
    {
      title: "3.Onboarding new hires",
      content:
        "The bots can provide credentials to assign the new employee, which onboarding documents to send, etc."
    },
    {
      title: "4.Employee data management",
      content:
        "Minimising the risk of improper data entries."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* ===== HEADER ===== */}
      <div className="hr-header">
        {/* LEFT */}
        <div
          className="hr-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="hr-header-overlay" />

          <div className="hr-header-badge">
            <div className="hr-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Robotic process automation - Use Cases</span>

            <span className="hr-arrow">›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="hr-header-right">
          <div className="hr-triangle-left" />
          <div className="hr-triangle-right" />

          <div className="hr-title-group">
            <FaUserTie style={{ fontSize: "32px", color: "#2fb7a4" }} />
            <h2>Human Resource</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN SECTION ===== */}
      <div className="hr-main">
        {/* IMAGE */}
        <div className="hr-img-wrapper">
          <img src={humanResourceImg} alt="" />
        </div>

        {/* ACCORDION */}
        <div className="hr-accordion">
          {data.map((item, i) => (
            <div key={i} className="hr-accordion-item">
              <div
                className="hr-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="hr-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="hr-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HumanResourcePage;
